// extracted by css-extract-rspack-plugin
export default {"stateLabel":"HeaderState-module__stateLabel__vlM4W","duplicateIssueLink":"HeaderState-module__duplicateIssueLink__XhGcu"};